import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { usePaging } from "shared/features/utils";
import { Checkout } from "shared/models";
import { useStoreAPI } from "shared/services/api";

import { useAuthContext } from "~/features/auth";

export const useCheckouts = (page?: number) => {
  const { token } = useAuthContext();
  const api = useStoreAPI({ accessToken: token });
  const [checkouts, setCheckouts] = useState<Checkout[]>([]);
  const paging = usePaging(page);
  const { currentPage, setMeta, gotoPage } = paging;

  const { isLoading } = useQuery(
    ["checkouts", currentPage],
    () => api.getCheckouts(currentPage),
    {
      keepPreviousData: true,
      onSuccess: ({ data: { checkouts }, meta: { paging } }) => {
        setCheckouts(checkouts.map((checkout) => new Checkout(checkout)));
        setMeta(paging);
      },
    },
  );

  useEffect(() => {
    gotoPage(page || 1);
  }, [page]);

  return {
    checkouts,
    paging,
    isLoading,
  };
};
